// src/env.ts
var s = false ? [] : window;
var env = { ...process.env, ...s["env"] };

export {
  env
};
